import axios from '../Utility/axiosconfig'

const bidding = async (body) => {
    await axios.post('api/addbidoffer', body)
    return true
}

export default bidding
